import React, { useEffect } from 'react'
import { Downgraded, useHookstate, useState } from '@hookstate/core';
import { DisplayComments } from '~/components/DisplayComments'
import useOccurrenceComentState from '~/features/Occurrence/stores/OccurrenceCommentState';
import type { CommentDataProps } from '~/features/Dispatch/stores/DispatchCommentState';
import useOccurrenceState from '../../stores/OccurrenceState';

interface OccurrenceDisplayCommentsProps {
  readonly moveScrolltoComment?: boolean
}

export default function OccurrenceDisplayComments({ moveScrolltoComment }: OccurrenceDisplayCommentsProps) {
  const [syncSuccess, setSyncSuccess] = React.useState(true)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [syncError, setSyncError] = React.useState<string | null>(null)

  const { occurrence } = useOccurrenceState();
  const { allCurrentComments, syncPreviousComments } = useOccurrenceComentState();
  const loading = useState(true)
  const allCurrentCommentsValue = allCurrentComments().attach(Downgraded).value;
  const commentList = useHookstate<readonly CommentDataProps[]>([]);
  const commentIsCompressed = useHookstate(true);

  const populateComments = () => {
    commentList.set(allCurrentCommentsValue ? allCurrentCommentsValue.map(element => element).sort(sortComment) : []);
  }

  const getCommentsFromOccurrenceId = async () => {
    setSyncSuccess(true)
    setSyncError(null)

    try {
      const success = await syncPreviousComments(occurrence().id.get());

      if (!success) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários.')
      } else if (commentList.get().length &&
        commentList[0].occurrenceId.get() &&
        occurrence().id.get() != commentList[0].occurrenceId.get()) {
        setSyncSuccess(false)
        setSyncError('Erro ao sincronizar comentários relacionados a ocorrência.')
      }
    } catch (error) {
      console.error('Erro ao buscar comentários:', error)
      setSyncSuccess(false)
      setSyncError(error instanceof Error ? error.message : 'Erro desconhecido')
    }
  }

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      loading.set(true)
      await getCommentsFromOccurrenceId()
      if (isMounted) {
        loading.set(false)
      }
    }

    fetchData()

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    populateComments();
  }, [allCurrentCommentsValue]);

  function sortComment(commentA: CommentDataProps, commentB: CommentDataProps) {
    const dateA = new Date(commentA.createdAt).getTime()
    const dateB = new Date(commentB.createdAt).getTime()
    return dateB - dateA
  }

  return (
    <DisplayComments
      comments={commentList}
      commentIsCompressed={commentIsCompressed}
      isEdit={true}
      isOccurrence={true}
      moveScrolltoComment={moveScrolltoComment}
      loading={loading.get()}
      refresh={syncSuccess}
      refreshAction={getCommentsFromOccurrenceId}
    />
  )
}